import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Stack, Typography, Link } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';

export default function Login() {

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Iniciar sesión en el mercado</Typography>

        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2">¿Eres nuevo?</Typography>

          <Link to={PATH_AUTH.register} component={RouterLink} variant="subtitle2">
            Crea una cuenta
          </Link>
        </Stack>
      </Stack>

      <AuthLoginForm />

    </LoginLayout>
  );
}
